import React from 'react';
import './style.css';

const MetricsTable = ({ filter, rows = [], totalRecords = 0, onPageChange }) => {
    const { page = 1, itemsPerPage = 10 } = filter || {};

    const metricKeys = rows.length > 0
        ? Object.keys(rows[0]).filter(key => !['stt', 'salesEmployeeName', 'id'].includes(key))
        : [];

    const totalPages = Math.ceil(totalRecords / itemsPerPage);

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 10;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (page <= 4) {
                for (let i = 1; i <= 5; i++) pages.push(i);
                pages.push('...');
                pages.push(totalPages);
            } else if (page >= totalPages - 3) {
                pages.push(1);
                pages.push('...');
                for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i);
            } else {
                pages.push(1);
                pages.push('...');
                for (let i = page - 1; i <= page + 1; i++) pages.push(i);
                pages.push('...');
                pages.push(totalPages);
            }
        }

        return pages;
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            onPageChange({ page: newPage, itemsPerPage });
        }
    };

    const handleItemsPerPageChange = (e) => {
        const newSize = Number(e.target.value);
        onPageChange({ page: 1, itemsPerPage: newSize });
    };

    const displayedRows = filter.filteredRows || rows;

    const paginatedRows = displayedRows.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    return (
        <div className="sales-dashboard">
            <div className="table-container">
                <div className="table-wrapper">
                    <table className="data-table">
                        <thead className="table-header">
                            <tr>
                                <th rowSpan={2} className="header-cell header-cell-rowspan">STT</th>
                                <th rowSpan={2} className="header-cell header-cell-rowspan">Tên nhân viên sales</th>
                                {metricKeys.map((key) => (
                                    <th key={key} colSpan={3} className="header-cell header-cell-center">
                                        {rows[0][key]?.displayName || key}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                {metricKeys.map((key) =>
                                    ['quantity', 'target', 'percentAchieved'].map((subKey) => (
                                        <th key={`${key}-${subKey}`} className="sub-header-cell">
                                            {subKey === 'quantity' ? 'Số lượng' : subKey === 'target' ? 'Target' : '% Đạt'}
                                        </th>
                                    ))
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedRows.map((row, index) => (
                                <tr key={row.id || index} className="table-row">
                                    <td className="table-cell">{row.stt}</td>
                                    <td className="table-cell sales-rep-cell">
                                        {row.salesEmployeeName.split(' - ')[1] || row.salesEmployeeName}
                                    </td>
                                    {metricKeys.map((key) =>
                                        ['quantity', 'target', 'percentAchieved'].map((subKey) => (
                                            <td key={`${key}-${subKey}`} className="table-cell table-cell-center">
                                                {row[key]?.[subKey]?.toLocaleString() ?? 0}
                                            </td>
                                        ))
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination-container">
                    <div className="pagination-info">
                        {(totalRecords === 0)
                            ? '0 items'
                            : `${(page - 1) * itemsPerPage + 1} - ${Math.min(page * itemsPerPage, totalRecords)} of ${totalRecords} items`}
                    </div>

                    <div className="pagination-controls">
                        <div className="page-numbers">
                            {getPageNumbers().map((p, i) => (
                                <button
                                    key={i}
                                    onClick={() => typeof p === 'number' && handlePageChange(p)}
                                    disabled={p === '...'}
                                    className={`page-button ${p === page ? 'active' : ''}`}
                                >
                                    {p}
                                </button>
                            ))}
                        </div>

                        <button
                            onClick={() => handlePageChange(page + 1)}
                            disabled={page === totalPages || totalPages === 0}
                            className="nav-button"
                        >
                            <span className="nav-arrow">›</span>
                        </button>

                        <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="items-per-page"
                            aria-label="Select number of items per page"
                        >
                            <option value={10}>10/page</option>
                            <option value={25}>25/page</option>
                            <option value={50}>50/page</option>
                            <option value={100}>100/page</option>
                        </select>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default MetricsTable;
